import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { CurrencyModel } from '../components/input/rules/implementations/currency.model';
import { CreditCardCVVModel } from '../components/input/rules/implementations/creditCardCVV.model';
import { DependentMeepServerModel } from './dependent.model';

export class RechargeCardId {
  cardId: string;
  ownerId: string;
  cardBrand: number;
}

export class RechargeModel {
  transactionSource = 1;
  transactionType = 1;
  installments = 1;
  receiverId: string;
  metadata: object;
  amount: number;
  amountToShow: string;
  card: RechargeCardId;
  cvv: string;
  dependent: DependentMeepServerModel;

  amountInputModel = new InputModel(false, false, 'tel', 'R$ 0,00', [new RequiredModel()], new CurrencyModel());
  cvvInputModel = new InputModel(false, true, 'tel', 'CVV', [new RequiredModel()], new CreditCardCVVModel());

  constructor() {
    this.card = new RechargeCardId();
    this.amountInputModel.setIsInputCurrencyRecharge();
    this.cvvInputModel.setIsInputCurrencyRecharge();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/recharge.model.ts